import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ApiResponse } from '@shared/models';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { PartnerModel, VoivodeshipModel } from '../model';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    printPdf(snapshotId: string, partner: PartnerModel): Observable<unknown> {
        const params = {
            name: partner.name,
            email: partner.email,
            phoneNumber: partner.phone,
            address: {
                city: partner.address.city,
                street: partner.address.street,
                houseNumber: partner.address.houseNumber,
            },
        };

        return this.httpClient.post(`api/public/metrix/pdf`, { snapshotId, partner: params }, { responseType: 'blob', observe: 'response' }).pipe(
            map((response) => response.body),
            filter((body) => body !== null),
            tap((body: Blob) => {
                const binaryData = [body];
                const downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: 'blob' }));
                downloadLink.setAttribute('download', `${snapshotId}.pdf`);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }),
        );
    }

    createLead(snapshotId: string, partnerId: string, phoneNumber: string): Observable<unknown> {
        const params = {
            snapshotId,
            phone: phoneNumber,
            storePublic: {
                id: partnerId,
            },
        };

        return this.httpClient.skipErrorHandler().post(`api/public/metrix/lead`, params);
    }

    getPartners(): Observable<PartnerModel[]> {
        return this.httpClient.get<ApiResponse<PartnerModel[]>>('api/public/stores-public?limit=9999').pipe(map((response) => response.data));
    }

    getVoivodeships(): Observable<VoivodeshipModel[]> {
        return this.httpClient.get<ApiResponse<VoivodeshipModel[]>>('api/public/polish-voivodeships').pipe(map((response) => response.data));
    }
}
